import React, { useEffect, useState } from 'react';
import classes from "./style.module.scss";
import Button from '../../component/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { Images } from '../../assets';
import Exported from '../../service/endpoints';
import request from '../../service';
import Loader from '../../component/Loader';
import { Toast } from '../../service/toast';
import { saveLoadingState } from '../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';

const DeleteUser = () => {
  const [showSuccessScreen, setShowSuccessScreen] = useState(false)
  const [textMessage, setTextMessage] = useState('Processing Request ....')
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const encryptedSlug = searchParams.get('encryptedSlug') || location.search?.split(('?encryptedSlug='))?.at(1)?.split('&')[0]
    const iv = searchParams.get('iv') || location.search?.split(('&iv='))?.at(1)
    if(encryptedSlug && iv) {
      deleteUserAcc(encryptedSlug, iv)
    }
  }, [])

  const deleteUserAcc = (slug, iv) => {
    let url = `${Exported.Endpoints.deleteUser}?encryptedSlug=${slug}&iv=${iv}`;
    let paramsObj = {
      encryptedSlug: slug,
      iv: iv,
    }
    dispatch(saveLoadingState(true));
    request({
      url: url,
      method: Exported.APIMethods.DELETE,
      data: { ...paramsObj }
    }).then((res) => {
      if (res?.data?.status) {
        const response = res?.data?.data
        console.log(res)
        dispatch(saveLoadingState(false));
        setShowSuccessScreen(true)
        // Toast({
        //   type: "success",
        //   message: "Deleted Successfully!...",
        // });
        // setTimeout(() => {
        //   setShowSuccessScreen(false)
        //   handleLogin()
        // }, 3000)
      }
    }).catch((err) => {
      dispatch(saveLoadingState(false));
      setTextMessage(err?.response?.data?.message || "Unable to process the request!..") // User already deleted
      Toast({
        type: "error",
        message: err?.response?.data?.message || "Unable to process the request!..",
      });
    });
  }

  const handleLogin = () => {
    navigate('/auth/login');
  };

  return (
    <>
      {showSuccessScreen ?
        <div className='flex items-center justify-center'>
          <div className={`${classes.successPage}`}>
            <img src={Images.successGif} className={`${classes.successGif}`} />
            <p className={`${classes.successMessage} mb-5`}>SUCCESS!</p>
            <p className={`${classes.successText} mb-8`}>Account deleted successfully </p>
            {/* <Button text={"Login"} className={`w-[70%] mx-auto`} onClick={handleLogin} /> */}
          </div>
        </div> :
        <div className='flex items-center justify-center h-[100%]'>{textMessage}</div>
      }
    </>
  );
}

export default DeleteUser;
